import { CloseOutlined } from "@ant-design/icons";
import { Form, FormInstance, FormProps, Input, Modal } from "antd";
import { useForm } from 'antd/lib/form/Form';
import { useEffect, useRef, useState } from "react";
import * as UnitApi from '../../../../api/unit/unitApi';
import './style.scss';
interface ModalProps {
  isOpen: boolean
  inForNationwide?: UnitApi.INationwide
  closeModal: () => void
  onSubmitFormEdit: (isSucces: boolean, errorMessage?: string) => void
}

const ModalEditArea: React.FC<ModalProps> = ({
  isOpen, inForNationwide, closeModal, onSubmitFormEdit
}) => {
  const [form] = useForm();
  const inputRef = useRef<FormInstance>(null);
  const submitForm = () => {
    if (inputRef.current) {
      inputRef.current.submit();
    }
  };

  const onFinish: FormProps["onFinish"] = async (value) => {
    const result = await UnitApi.updateNationwide(Number(inForNationwide?.id), value.code, value.title);
    if (result?.status) {
      onSubmitFormEdit?.(true)
    } else {
      onSubmitFormEdit?.(false, result?.message)
    }
  };

  useEffect(() => {
    if (isOpen) {
      form.setFieldsValue({
        'code': inForNationwide?.code,
        'title': inForNationwide?.title
      })
    } else {
      form.resetFields()
    }

  }, [isOpen])

  return (
    <Modal
      title={<div className="bg-FCFCFD d-flex justify-betweeen align-center py-4 px-6 w-full border-b-F0F0F0">
        <span className="text-base text-344054 fw-500 font-medium">Chỉnh sửa toàn quốc</span>
        <CloseOutlined className="text-base text-8B8B8B" onClick={closeModal} />
      </div>}
      open={isOpen}
      onCancel={closeModal}
      centered
      className="w-modal modal-content-creat-area ant-modal-size"
      closeIcon={false}
      footer={<div className="bg-FCFCFD d-flex justify-end align-center py-2 px-6 w-full border-t-F0F0F0 gap-2">
        <button className="text-sm text-344054 border-F2F4F7 bg-white h-8 px-15-px font-regular rounded-2 shadow-btn-save" onClick={closeModal}>Huỷ</button>
        <button className="text-white text-sm bg-096DD9 border-none shadow-btn-save rounded-2 h-8 px-15-px font-regular shadow-btn-save"
          onClick={submitForm}>
          Xác nhận
        </button>
      </div>}
    >
      <Form
        form={form}
        ref={inputRef}
        onFinish={onFinish}
        name="nest-messages"
        initialValues={{ remember: true }}
      >
        <div className="d-flex flex-column gap-18-px p-6">
          <div className="d-flex flex-column gap-1">
            <p className="text-sm  font-regular text-344054 d-flex gap-2 align-center">
              <span className="text-F5222D">*</span>
              Mã trực thuộc
            </p>
            <Form.Item
              rules={[{ required: true, message: 'Nhập mã trực thuộc!' }]}
              className="m-none-form-item text-explan"
              name='code'
            >
              <Input
                placeholder="Mã trực thuộc"
                className="bg-FCFCFD border-F2F4F7 text-sm rounded-2  font-regular  input-custom  h-8"
              />
            </Form.Item>
          </div>

          <div className="d-flex flex-column gap-1">
            <p className="text-sm  font-regular text-344054 d-flex gap-2 align-center">
              <span className="text-F5222D">*</span>
              Tên trực thuộc
            </p>
            <Form.Item
              name='title'
              rules={[{ required: true, message: 'Nhập tên trực thuộc!' }]}
              className="m-none-form-item text-explan"
            >
              <Input
                placeholder="Tên trực thuộc"
                className="bg-FCFCFD border-F2F4F7 text-sm rounded-2  font-regular  input-custom  h-8"
              />
            </Form.Item>
          </div>
        </div>
      </Form>
    </Modal>
  )
}
export default ModalEditArea
